import React from 'react';
import { WorkItem } from '../workitems/workItemTypes';
import './CalendarAppointment.css';

/** View-model for a single appointment row, flattened from the technician columns. */
export interface CalendarAppointmentVM {
  /** The underlying work item — passed back on click for the detail popover. */
  workItem: WorkItem;
  /** Pre-formatted start time, e.g. "09:30". */
  startTime: string;
  title: string;
  technicianName: string;
}

interface CalendarAppointmentProps {
  appointment: CalendarAppointmentVM;
  onClick: (e: React.MouseEvent, workItem: WorkItem) => void;
}

export const CalendarAppointment: React.FC<CalendarAppointmentProps> = ({
  appointment,
  onClick,
}) => (
  <div className="cal-appt" onClick={(e) => onClick(e, appointment.workItem)}>
    <span className="cal-appt__time">{appointment.startTime}</span>
    <span className="cal-appt__title">{appointment.title}</span>
    <span className="cal-appt__tech">{appointment.technicianName}</span>
  </div>
);
